import React from "react"

const EmptyPanel = () => {
  return <span>I am empty. Make me useful</span>
}

export default EmptyPanel
